import React, { useContext, useEffect, useState } from "react";
import { v4 as uuidv4 } from "uuid";

import { Box, Button, Grid, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { FormContext } from "context/formContext";
import { StyledAddressWrapper, StyledFooterBox, StyledTitle } from "./styles";
import { useGetMealMeStoresListMutation } from "api";
import { setError } from "features/error";
import { useDispatch } from "react-redux";
import Preloader from "./Preloader/Preloader";
import { useMatchMobile } from "hooks/useMatchMobile";

const BusinessInfo = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [getStoresList, { isLoading }] = useGetMealMeStoresListMutation();

  const { formData, updateFormData } = useContext(FormContext);
  const [restaurantList, setRestaurantList] = useState([]);
  const [errorMessage, setErrorMessage] = useState("");
  const { isMatchMobile } = useMatchMobile();

  const goBack = () => {
    navigate(-1);
  };

  const geNext = () => {
    if (formData._id === null) {
      dispatch(
        setError({
          title: "",
          errorMessage: "Oops! Something went wrong",
          isServer: false,
          isTimeout: false,
        })
      );
    } else {
      if (!formData._id) {
        setErrorMessage("Please Select Your Business");
      } else {
        navigate("/emailInfo");
        setErrorMessage("");
      }
    }
  };

  useEffect(() => {
    if (formData.restaurantName) {
      try {
        const dataModel = {
          restaurantName: formData.restaurantName,
          addressInfo: formData.addressInfo,
        };
        getStoresList(dataModel)
          .unwrap()
          .then((res) => {
            if (!res.error) {
              setRestaurantList(res);
              updateFormData(res[0]);
            }
          })
          .catch((error) => {
            dispatch(
              setError({
                title: "",
                errorMessage: "Oops! Something went wrong",
                isServer: false,
                isTimeout: false,
              })
            );
          });
      } catch (error) {
        console.error(error);

        // Expected output: ReferenceError: nonExistentFunction is not defined
        // (Note: the exact output may be browser-dependent)
      }
    }
  }, []);

  const handleSelectBusiness = (restaurant) => {
    updateFormData(restaurant);
  };

  const styleChek = isMatchMobile
    ? {
        height: "100vh",
        overflow: "auto",
        mt: 3,
        display: "flex",
        flexDirection: "column",
        px: 0.5,
      }
    : { mt: 3, px: 0.5 };

  return (
    <Box>
      {restaurantList.length ? (
        <StyledTitle sx={{ fontSize: "36px" }}>
          Select Your Business
        </StyledTitle>
      ) : null}
      <Box
      // sx={{
      //   display: "flex",
      //   justifyContent: "space-between",
      //   flexDirection: "column",
      // }}
      >
        {isLoading && <Preloader overlay />}
        <Box sx={{ display: "flex", flexDirection: "column", gap: 3, mt: 3 }}>
          {restaurantList.map((item) => {
            return (
              <StyledAddressWrapper
                key={item._id}
                onClick={() => handleSelectBusiness(item)}
                isSelected={Boolean(item._id === formData._id)}
                sx={{ boxShadow: 3 }}
              >
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "flex-start",
                    width: "100%",
                  }}
                >
                  <Typography sx={{ minWidth: "100px", textAlign: "left" }}>
                    <b>Name:</b>
                  </Typography>
                  <Typography align="left">{item.restaurantName}</Typography>
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "baseline",
                    justifyContent: "flex-start",
                    width: "100%",
                  }}
                >
                  <Typography sx={{ minWidth: "100px", textAlign: "left" }}>
                    <b>Address:</b>
                  </Typography>
                  <Typography align="left">
                    {item?.addressInfo?.address1}
                    <br />
                    {`${item?.addressInfo?.city || ""} ${
                      item?.addressInfo?.state || ""
                    } ${item?.addressInfo?.zipCode || ""}`}
                  </Typography>
                </Box>
              </StyledAddressWrapper>
            );
          })}
          {restaurantList.length ? (
            <StyledAddressWrapper
              key={uuidv4()}
              onClick={() => handleSelectBusiness({ _id: null })}
              isSelected={Boolean(formData?._id === null)}
              sx={{ boxShadow: 3 }}
            >
              <Typography sx={{ width: "100%", textAlign: "center" }}>
                None of the above
              </Typography>
            </StyledAddressWrapper>
          ) : null}
        </Box>
        <Box
          sx={{
            height: "50px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          {errorMessage && (
            <Typography color="error">{errorMessage}</Typography>
          )}
        </Box>
      </Box>

        <Box sx={{ mt: 2 }}>
          <StyledFooterBox sx={{ boxShadow: 4 }}>
            <Grid container m-0 p-0>
              <Grid item lg={6} md={12} xs={12} sm={12} m-0 p-0></Grid>
              <Grid item lg={6} md={12} xs={12} sm={12} m-0 p-0>
                <Button variant="outlined" onClick={goBack}>
                  Back
                </Button>
                <Button variant="contained" onClick={geNext}>
                  Next
                </Button>
              </Grid>
            </Grid>
          </StyledFooterBox>
        </Box>
    </Box>
  );
};

export default BusinessInfo;
